import React, { useEffect } from 'react';
import './ClubPage.css';

/**
 * Hidden landing page for the Telegram group ad campaign (Meta ads point here).
 *
 * Route: /club  (harday.co.in/club)
 * - Intentionally NOT linked from anywhere on the site. Reachable by direct URL only.
 * - No auth required. Mobile-first, celebratory theme.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * META PIXEL ID — SINGLE PLACE TO EDIT
 * ─────────────────────────────────────────────────────────────────────────────
 * The real Pixel ID is committed here on purpose. frontend/.env is gitignored
 * (see /.gitignore "*.env"), and Dockerfile.frontend builds by copying the repo
 * tree and running `yarn build` — so an untracked .env would never reach the
 * production bundle. A Pixel ID is not a secret; it ships in client-side JS.
 *
 * REACT_APP_META_PIXEL_ID still wins if set, for local/staging overrides.
 */
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '2186913925183925';

const TELEGRAM_URL = 'https://t.me/fiftykclub';

// Tracks whether fbq('init') has already run for this document lifetime.
// In an SPA the component can mount more than once (React StrictMode double-
// invokes effects in development, and a user can navigate away from /club and
// back). 'init' must happen exactly once — 'track' fires per page view.
let pixelInitialised = false;

// Standard Meta Pixel base code. The stub below queues any fbq() calls in
// n.queue and replays them once fbevents.js finishes loading, so a track call
// made immediately after this runs is safe — there is no race to guard against.
const initMetaPixel = (pixelId) => {
  if (typeof window === 'undefined' || !pixelId) return;
  if (pixelInitialised) return;

  if (!window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
  }

  window.fbq('init', pixelId);
  pixelInitialised = true;
};

// Fires a PageView. Separate from init so that re-entering /club via
// client-side routing reports a fresh page view without re-initialising.
const trackPageView = () => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', 'PageView');
};

const ClubPage = () => {
  useEffect(() => {
    // Keep this hidden ad page out of search engines.
    const robotsMeta = document.createElement('meta');
    robotsMeta.setAttribute('name', 'robots');
    robotsMeta.setAttribute('content', 'noindex,nofollow');
    document.head.appendChild(robotsMeta);

    const previousTitle = document.title;
    document.title = 'Harday Club';

    // Load the pixel (once) and report this page view.
    initMetaPixel(META_PIXEL_ID);
    trackPageView();

    return () => {
      document.title = previousTitle;
      if (robotsMeta.parentNode) robotsMeta.parentNode.removeChild(robotsMeta);
    };
  }, []);

  const handleJoinClick = () => {
    // Fire the Lead event BEFORE opening the Telegram link.
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
    }
  };

  return (
    <div className="club-page">
      {/*
        Meta Pixel <noscript> fallback, kept inside ClubPage so it is scoped to
        /club and never renders on the rest of the app.

        Two things worth knowing about this tag in a client-rendered CRA SPA:

        1. It must be written via dangerouslySetInnerHTML. React does not
           serialise JSX children of <noscript> on the client — passing an <img>
           element normally emits an empty "<noscript></noscript>" and the
           beacon is silently lost.
        2. Even correct, it cannot fire for a genuinely JS-disabled visitor:
           without JS, React never mounts and nothing here is rendered at all.
           Making it work for those users would mean hardcoding it into
           public/index.html, which would load the pixel across the whole
           Harday site — deliberately avoided. It is kept because it costs
           nothing and starts working if /club is ever pre-rendered.
      */}
      <noscript
        dangerouslySetInnerHTML={{
          __html:
            `<img height="1" width="1" style="display:none" alt="" ` +
            `src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`,
        }}
      />

      {/* Floating festive emoji accents (pure CSS, no heavy JS) */}
      <div className="club-confetti" aria-hidden="true">
        <span style={{ left: '6%', animationDelay: '0s' }}>🎉</span>
        <span style={{ left: '20%', animationDelay: '1.4s' }}>✨</span>
        <span style={{ left: '38%', animationDelay: '0.7s' }}>🎊</span>
        <span style={{ left: '55%', animationDelay: '2.1s' }}>💜</span>
        <span style={{ left: '72%', animationDelay: '0.3s' }}>🥳</span>
        <span style={{ left: '88%', animationDelay: '1.8s' }}>🎈</span>
      </div>

      <main className="club-card">
        {/* Harday wordmark */}
        <div className="club-brand">Harday</div>

        {/* Main headline (Hinglish) */}
        <h1 className="club-headline">
          Fake earning apps se tang? Is group mein sirf wo platform milenge jinse paisa aata hai
          jitna kaha jaata hai
        </h1>

        <div className="club-cta-wrap">
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleJoinClick}
            className="club-join-btn"
          >
            <span className="club-join-emoji" aria-hidden="true">🚀</span>
            Join Telegram
          </a>
          <div className="club-free">Free</div>
        </div>
      </main>
    </div>
  );
};

export default ClubPage;
